<template>
  <div>
    <b-breadcrumb :items="breadCrumbs" />

    <div class="row mb-3">
      <div class="col-12">
        <b-btn
          variant="primary"
          size="md"
          class="float-right"
          :to="'/shipments/add'"
          >Add Shipment</b-btn
        >
      </div>
    </div>

    <b-row class="mt-3">
      <b-col md="12">
        <b-table :items="shipments" :fields="fields" v-if="shipments">
          <template slot="cell(stock)" slot-scope="row">
            <ul>
              <li :key="index" v-for="(item, index) in row.item.stock">
                {{
                  item.quantity + " X " + item.model + " (" + item.name + ")"
                }}
              </li>
            </ul>
          </template>
          <template slot="cell(actions)" slot-scope="row">
            <div style="width:300px;" v-if="row.item.status_id != 3">
              <b-button
                size="sm"
                variant="warning"
                class="ml-2"
                :to="'/shipments/' + row.item.shipment_id + '/edit/'"
                >Edit</b-button
              >
              <b-button
                size="sm"
                variant="info"
                class="ml-2"
                :to="'/shipments/' + row.item.shipment_id + '/stock/'"
                >Stock</b-button
              >
              <b-button
                size="sm"
                variant="danger"
                class="ml-2"
                @click="deleteConfirm(row.item.shipment_id)"
                >Delete</b-button
              >
              <b-button
                size="sm"
                variant="primary"
                class="ml-2"
                @click="updateShipmentStatus(row.item.shipment_id, 2)"
                v-if="row.item.status_id == 1"
                >Book In</b-button
              >
              <b-button
                size="sm"
                variant="primary"
                class="ml-2"
                @click="updateShipmentStatus(row.item.shipment_id, 3)"
                v-if="row.item.status_id == 2"
                >Arrived</b-button
              >
            </div>
            <div style="width:300px;" v-if="row.item.status_id == 3">
              Shipment Complete - No action required
            </div>
          </template>
        </b-table>
      </b-col>
    </b-row>

    <b-row v-if="!shipments || shipments.length == 0">
      <b-col md="6" class="my-1 offset-md-3">
        <b-alert show variant="success">No shipments yet!</b-alert>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "shipments",
  components: {},
  data() {
    return {
      shipments: null,
      fields: [
        { key: "shipment_id", label: "#", sortable: true },
        { key: "shipping_date", label: "Shipping Date" },
        { key: "expected_arrival_date", label: "Arrival Date" },
        { key: "stock", label: "Stock" },
        { key: "name", label: "Status" },
        { key: "actions", label: "" }
      ],
      breadCrumbs: [
        { text: "Dashboard", to: { name: "dashboard" } },
        { text: "Shipments", active: true }
      ]
    };
  },
  mounted: function() {
    this.getShipments();
  },
  methods: {
    getShipments: function() {
      let loader = this.$loading.show();
      this.$http.get(this.APIURL + this.BRAND + "/shipments").then(
        response => {
          this.shipments = response.data.shipments;

          console.log(this.shipments);

          loader.hide();
        },
        error => {
          loader.hide();
          console.log(error);
        }
      );
    },
    deleteConfirm(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You want to delete shipment: " + id,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          this.deleteShipment(id);
        }
      });
    },
    deleteShipment(id) {
      let loader = this.$loading.show();
      this.$http.delete(this.APIURL + this.BRAND + "/shipments/" + id).then(
        () => {
          this.$swal({
            title: "Success!",
            showConfirmButton: false,
            timer: 1000,
            html: "Shipment deleted successfully!",
            type: "success",
            onClose: () => {
              loader.hide();
              this.getShipments();
            }
          });
        },
        error => {
          console.log(error);
        }
      );
    },
    updateShipmentStatus(id, status_id) {
      let loader = this.$loading.show();
      this.$http
        .put(this.APIURL + this.BRAND + "/shipments/" + id + "/status", {
          status_id: status_id
        })
        .then(
          response => {
            if (response.data.status == "success") {
              this.$swal({
                title: "Success!",
                showConfirmButton: false,
                timer: 1000,
                html: "Shipment updated successfully!",
                type: "success",
                onClose: () => {
                  loader.hide();
                  this.getShipments();
                }
              });
            } else {
              this.$swal({
                title: "Error!",
                showConfirmButton: false,
                timer: 1500,
                html: response.data.error,
                type: "success",
                onClose: () => {
                  loader.hide();
                }
              });
            }
          },
          error => {
            console.log(error);
          }
        );
    }
  }
};
</script>
